module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var i = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      i = u(n(0)),
      o = u(n(2));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var d = function d(e) {
    return e.minWidth && e.maxWidth ? e.minWidth <= e.windowWidth && e.maxWidth >= e.windowWidth ? i.default.createElement("br", null) : " " : e.minWidth ? e.minWidth <= e.windowWidth ? i.default.createElement("br", null) : " " : e.maxWidth && e.maxWidth >= e.windowWidth ? i.default.createElement("br", null) : " ";
  };

  t.default = function (e) {
    return e.windowWidth ? i.default.createElement(d, e) : i.default.createElement(o.default, null, function (t) {
      return i.default.createElement(d, r({
        windowWidth: t
      }, e));
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(0));

  var o = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.state = {
        windowWidth: n.getWindowWidth()
      }, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.default.Component), r(t, [{
      key: "getWindowWidth",
      value: function value() {
        return window.innerWidth || document.documentElement.clientWidth;
      }
    }, {
      key: "updateWindowWidth",
      value: function value() {
        return this.setState({
          windowWidth: this.getWindowWidth()
        });
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.updateWindowWidth(), window.addEventListener("resize", this.updateWindowWidth.bind(this));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.updateWindowWidth.bind(this));
      }
    }, {
      key: "render",
      value: function value() {
        return this.props.children(this.state.windowWidth);
      }
    }]), t;
  }();

  t.default = o;
}]);